<!-- eslint-disable vue/no-v-html -->
<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex xs12 sm9>
            <filters ref="filters" @filter="filter" />
          </v-flex>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="clave"
              class="substatus dataTable"
              sort-by="code"
              :sort-desc="false"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field
                  v-model.trim="search"
                  dense
                  clearable
                  hide-details
                  :label="$t('view.commons.search')"
                  append-icon="mdi-magnify"
                  @keydown.enter="refreshSearch"
                  @click:append="refreshSearch"
                  @click:clear="clearSearch" />
              </template>
              <template #item.descripcion="{ item }">
                <div class="d-inline-flex align-center">
                  <span v-html="hasVacio(item.descripcion)"></span>
                  <v-chip v-if="item.payfac" class="ml-1" dense x-small color="primary">
                    <strong>{{ $t("view.operativos.substatus.form.payfac.th") }}</strong>
                  </v-chip>
                  <v-chip v-if="item.gaps" class="ml-1" dense x-small>
                    <strong>{{ $t("view.operativos.substatus.form.gaps.th") }}</strong>
                  </v-chip>
                </div>
              </template>
              <template #item.accion="{ item }">
                <span v-html="hasVacio(item.accion)"></span>
              </template>
              <template #item.statusprecontacto="{ item }">
                <span v-html="hasVacio(item.statusprecontacto)"></span>
              </template>
              <template #item.postest="{ item }">
                <span v-html="hasVacio(item.postest)"></span>
              </template>
              <template #item.tipo="{ item }">
                <span v-html="tipoData(item.tipo)"></span>
              </template>
              <template #item.acciones="{ item }">
                <buttons
                  :ref="`dataTableBtn_${item.clave}`"
                  :key="refreshkey"
                  :clave="item.clave"
                  :descripcion="item.descripcion"
                  :showdisable="item.status && $userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                  @edit="edit"
                  @disable="disable"
                  @audit="audit" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>
  </v-card>
</template>

<script>
import Filters from "@/views/operativos/substatus/Filters"; /** *******************************/
import SubstatusAPI from "@/services/operativos/substatus"; /** *******************************/
import Buttons from "@/components/datatable/Buttons"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { disableSwal } from "@/constants/sweet-alerts";
import { handleResponse } from "@/helpers/http-response-handler";

export default {
  name: "DataTable"
  , components: { Buttons, Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , refreshkey: 0
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.operativos.substatus.form.code.th"), align: "center", sortable: true, class: "code", cellClass: "code", value: "code" }
              , { text: this.$t("view.operativos.substatus.form.descripcion.th"), align: "left", sortable: true, class: "descripcion", cellClass: "descripcion", value: "descripcion" }
              , { text: this.$t("view.operativos.substatus.form.accion.th"), align: "left", sortable: true, class: "acciones", cellClass: "acciones", value: "accion" }
              , { text: this.$t("view.operativos.substatus.form.statusprecontacto.th"), align: "left", sortable: true, class: "statuspc", cellClass: "statuspc", value: "statusprecontacto" }
              , { text: this.$t("view.operativos.substatus.form.postest.th"), align: "center", sortable: true, class: "postest", cellClass: "postest", value: "postest" }
              , { text: this.$t("view.operativos.substatus.form.tipo.th"), align: "center", sortable: true, class: "tipo", cellClass: "tipo", value: "tipo" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "acciones" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await SubstatusAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);
      this.refreshkey += 1;

      this.view.elem.datatable.loading = false;
    }
    , async edit(clave) {
      this.$emit("editRow", clave);
    }
    , async disable(clave) {
      if ((await this.$swal(disableSwal)).value) {
        if (handleResponse(await SubstatusAPI.disable({ clave }))) {
          this.load();
          if (clave == this.$parent.substatus.clave) this.$emit("editRow", clave);
        }
      }
    }
    , async audit(clave, descripcion) {
      this.$emit("auditRow", clave, descripcion);
    }
    , refreshData() {
      this.load();
    }
    , refreshSearch() {
      this.options.page = 1;
      this.load();
    }
    , clearSearch() {
      this.search = "";
      this.options.page = 1;
      this.load();
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          fls[key] = fls[key].join();
        } else {
          delete fls[key];
        }
      });
      this.options.page = 1;
      this.filtros = fls;
      await this.load();
    }
    , hasVacio(data) {
      return data ? data.replaceAll(",", ",&nbsp;&nbsp;&nbsp; ").replaceAll("VACIO", `<strong class='vacio'>${this.$t("view.operativos.substatus.vacio")}</strong>`) : "";
    }
    , tipoData(data) {
      let tipostr = "";
      if (data && data != "") {
        let tipoobj = JSON.parse(data);
        tipoobj.forEach((tipo) => {
          tipo = JSON.parse(tipo);
          tipostr += tipo.name == "VACIO" ? `<strong class='vacio popentryexit'>${this.$t("view.operativos.substatus.vacio")}</strong>,` : `<span class='popentryexit'>${tipo.name}</span>,`;
        });
        tipostr = tipostr.replace(/,\s*$/, "").replaceAll(",", ",&nbsp;&nbsp;&nbsp; ");
      }
      return tipostr;
    }
  }
};
</script>

<style>
.substatus .code {
  width: 100px !important;
  min-width: 100px !important;
  padding-left: 0 !important;
}
.substatus .acciones {
  max-width: 250px;
}
.substatus .statuspc {
  max-width: 250px;
}
.substatus .postest {
  width: 120px;
  min-width: 120px;
}
.substatus .tipo {
  width: 200px;
  max-width: 200px;
}
.substatus .vacio {
  color: var(--primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/substatus/DataTable.vue